module.exports = {
  Serializer: require('./lib/serializer'),
  Deserializer: require('./lib/deserializer'),
  Error: require('./lib/error')
};